import React from 'react';
interface RadioOption {
  value: string;
  label: string;
  description?: string;
}
interface RadioGroupProps {
  label?: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  options: RadioOption[];
  error?: string;
  helperText?: string;
}
export const RadioGroup: React.FC<RadioGroupProps> = ({
  label,
  name,
  value,
  onChange,
  options,
  error,
  helperText
}) => {
  return <div className="w-full" data-id="element-1637">
      {label && <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-1638">
          {label}
        </label>}
      <div className="space-y-3" data-id="element-1639">
        {options.map(option => <label key={option.value} className={`flex items-start p-4 border rounded-sm cursor-pointer transition-colors ${value === option.value ? 'border-greenback bg-green-50' : 'border-gray-200 hover:bg-gray-50'}`} data-id="element-1640">
            <div className="flex items-center h-5" data-id="element-1641">
              <input type="radio" name={name} value={option.value} checked={value === option.value} onChange={e => onChange(e.target.value)} className="h-4 w-4 text-greenback border-gray-300 focus:ring-greenback" data-id="element-1642" />
            </div>
            <div className="ml-3 text-sm" data-id="element-1643">
              <span className={`font-medium ${value === option.value ? 'text-greenback' : 'text-gray-900'}`} data-id="element-1644">
                {option.label}
              </span>
              {option.description && <p className="text-sm font-normal text-gray-500 mt-1" data-id="element-1645">
                  {option.description}
                </p>}
            </div>
          </label>)}
      </div>
      {helperText && !error && <p className="mt-2 text-xs font-normal text-gray-500" data-id="element-1646">{helperText}</p>}
      {error && <p className="mt-2 text-xs font-normal text-red-500" data-id="element-1647">{error}</p>}
    </div>;
};